import { SigningIn, signingInTitle } from '@traceio-org/auth-ui';
import { PRODUCTS, type ProductKey } from '@traceio-org/platform-contracts';
import type { HostState } from '../security/host';
import { useBootstrap } from './context';
import { usePageHeading } from './hooks';
import { HubFrame } from './ui';

export { rememberSigningInProduct, signingInProduct } from './signing-in-product';

/** The name in the heading: the customer's own name on a customer domain, else the product's. */
export function signingInName(productKey: ProductKey | null, host: HostState | null): string {
  if (host?.kind === 'customer-employee') return host.branding.displayName;
  if (host?.kind === 'customer-portal') return host.portalName;
  return productKey ? PRODUCTS[productKey].displayName : 'Trace';
}

/**
 * The hub's in-progress sign-in screen (the login page's silent check, the callback, the decision): the same
 * frame, heading and spinner as DestinationGate's and the static index.html shell, with no step text, so a sign-in
 * that crosses the hub and a product reads as one unchanging screen.
 */
export function SigningInPage({ productKey }: { productKey: ProductKey | null }) {
  const { host } = useBootstrap();
  const title = signingInTitle(signingInName(productKey, host));
  const headingRef = usePageHeading(title);
  return (
    <HubFrame productKey={productKey}>
      <SigningIn title={title} headingRef={headingRef} />
    </HubFrame>
  );
}
